import React, { useState, useEffect } from 'react';
import { Manage } from '../shared/Manage';
import { KeenIcon } from '@/components'
import { DeleteConfirmModal } from '@/components/DeleteConfirmModal';
import { DetailedViewWithPagination } from '../shared/DetailedViewWithPagination';

// Dữ liệu mẫu
const mockData = [
  {
    id: 1,
    name: 'Tiêu đề mẫu 1',
    date: '20/05/2025',
    data: 'Đây là nội dung mẫu số 1. Bạn có thể sử dụng nội dung này để kiểm tra giao diện hoặc tính năng hiển thị.'
  },
  {
    id: 2,
    name: 'Tiêu đề mẫu 2',
    date: '21/05/2025',
    data: 'Đây là nội dung mẫu số 2. Thông tin có thể được thay đổi hoặc mở rộng tùy vào yêu cầu thực tế.'
  },
  {
    id: 3,
    name: 'Tiêu đề mẫu 3',
    date: '22/05/2025',
    data: 'Nội dung mẫu số 3 cung cấp văn bản giả định để mô phỏng dữ liệu thực tế trong hệ thống.'
  },
  {
    id: 4,
    name: 'Tiêu đề mẫu 4',
    date: '23/05/2025',
    data: 'Văn bản mẫu số 4 dùng để kiểm tra cách bố trí và xử lý nội dung trong ứng dụng.'
  }
];


// Cấu hình cột
const columns = [
  { key: 'date', label: 'Date Create', type: 'text', width: '30%' },
  { key: 'data', label: 'Text (50 words)', type: 'text', width: '60%' }
];

const ManageContentModer = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  // Giả lập fetch data
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setData(mockData);
      setLoading(false);
    },200);
  }, []);

  // Xử lý các sự kiện
  const handleEdit = (item) => {
    console.log('Edit item:', item);
    // TODO: logic edit
  };

  const handleDelete = (item) => {
    setSelectedItem(item);
    setShowDeleteConfirm(true);
  };

  const confirmDelete = () => {
    if (selectedItem) {
      setData(prev => prev.filter(i => i.id !== selectedItem.id));
    }
    setShowDeleteConfirm(false);
    setSelectedItem(null);
  };

  const cancelAction = () => {
    setShowDeleteConfirm(false);
    setSelectedItem(null);
  };

  const totalPages = data.length;

  const handlePrev = () => {
    setCurrentPage((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const handleNext = () => {
    setCurrentPage((prev) => (prev < totalPages - 1 ? prev + 1 : prev));
  };

  // Sử dụng giá trị trực tiếp cho message xác nhận xóa
  const deleteConfirmMessageText = "Bạn có chắc chắn muốn xóa dữ liệu này không?";

  return (
    <div className="flex flex-col items-center">
      <Manage
        type="reference-data"
        tableProps={{
          data,
          loading,
          columns,
          onEdit: handleEdit,
          onDelete: handleDelete,
          emptyMessage: "Không có dữ liệu",
          deleteConfirmMessage: deleteConfirmMessageText
        }}
        className='w-full'
      />

      {/* Tiện ích data */}
      <DetailedViewWithPagination
        data={data}
        currentPage={currentPage}
        totalPages={totalPages}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handlePrev={handlePrev}
        handleNext={handleNext}
      />

      {showDeleteConfirm && (
        <DeleteConfirmModal
          show={showDeleteConfirm}
          message={deleteConfirmMessageText}
          onConfirm={confirmDelete}
          onCancel={cancelAction}
        />
      )}
    </div>
  );
};

export { ManageContentModer };
